import * as RollingDatePointOptionValues from './RollingDatePointOptionValues';
import { BACKWARD, FORWARD } from './RollingDateDirections';
import { DAY, MONTH, QUARTER, WEEK, YEAR } from './TimeUnits';
import { Map as ImmutableMap, Record, is } from 'immutable';
import isNumber from 'transmute/isNumber';
const isValidDirection = direction => {
  return direction === FORWARD || direction === BACKWARD;
};
const isValidTimeUnit = timeUnit => {
  return [DAY, MONTH, QUARTER, WEEK, YEAR].includes(timeUnit);
};
const RollingDatePointConfigDefaultValues = {
  direction: BACKWARD,
  timeUnit: DAY,
  value: 0
};
const RollingDatePointConfig = Record(RollingDatePointConfigDefaultValues, 'RollingDatePointConfig');
export const validateRollingDatePointConfig = (opts = {}) => {
  const {
    direction,
    timeUnit,
    value
  } = opts;
  if (!isValidDirection(direction)) {
    return false;
  }
  if (!isValidTimeUnit(timeUnit)) {
    return false;
  }
  if (!isNumber(value) || value < 0) {
    return false;
  }
  return true;
};
const OptionValueToRollingDatePointConfig = {
  [RollingDatePointOptionValues.TODAY]: RollingDatePointConfig({
    direction: BACKWARD,
    timeUnit: DAY,
    value: 0
  }),
  [RollingDatePointOptionValues.YESTERDAY]: RollingDatePointConfig({
    direction: BACKWARD,
    timeUnit: DAY,
    value: 1
  }),
  [RollingDatePointOptionValues.TOMORROW]: RollingDatePointConfig({
    direction: FORWARD,
    timeUnit: DAY,
    value: 1
  }),
  [RollingDatePointOptionValues.THIS_WEEK]: RollingDatePointConfig({
    direction: BACKWARD,
    timeUnit: WEEK,
    value: 0
  }),
  [RollingDatePointOptionValues.LAST_WEEK]: RollingDatePointConfig({
    direction: BACKWARD,
    timeUnit: WEEK,
    value: 1
  }),
  [RollingDatePointOptionValues.NEXT_WEEK]: RollingDatePointConfig({
    direction: FORWARD,
    timeUnit: WEEK,
    value: 1
  }),
  [RollingDatePointOptionValues.THIS_MONTH]: RollingDatePointConfig({
    direction: BACKWARD,
    timeUnit: MONTH,
    value: 0
  }),
  [RollingDatePointOptionValues.LAST_MONTH]: RollingDatePointConfig({
    direction: BACKWARD,
    timeUnit: MONTH,
    value: 1
  }),
  [RollingDatePointOptionValues.NEXT_MONTH]: RollingDatePointConfig({
    direction: FORWARD,
    timeUnit: MONTH,
    value: 1
  }),
  [RollingDatePointOptionValues.THIS_QUARTER]: RollingDatePointConfig({
    direction: BACKWARD,
    timeUnit: QUARTER,
    value: 0
  }),
  [RollingDatePointOptionValues.LAST_QUARTER]: RollingDatePointConfig({
    direction: BACKWARD,
    timeUnit: QUARTER,
    value: 1
  }),
  [RollingDatePointOptionValues.NEXT_QUARTER]: RollingDatePointConfig({
    direction: FORWARD,
    timeUnit: QUARTER,
    value: 1
  }),
  [RollingDatePointOptionValues.THIS_YEAR]: RollingDatePointConfig({
    direction: BACKWARD,
    timeUnit: YEAR,
    value: 0
  }),
  [RollingDatePointOptionValues.LAST_YEAR]: RollingDatePointConfig({
    direction: BACKWARD,
    timeUnit: YEAR,
    value: 1
  }),
  [RollingDatePointOptionValues.NEXT_YEAR]: RollingDatePointConfig({
    direction: FORWARD,
    timeUnit: YEAR,
    value: 1
  })
};
const OptionValueToRollingDatePointConfigMap = ImmutableMap(OptionValueToRollingDatePointConfig);
RollingDatePointConfig.fromRollingDatePointOptionValue = optionValue => OptionValueToRollingDatePointConfig[optionValue];
RollingDatePointConfig.toRollingDatePointOptionValue = rollingDatePointConfig => {
  const RollingDatePointEntry = OptionValueToRollingDatePointConfigMap.findEntry(knownConfig => is(knownConfig, rollingDatePointConfig));
  if (Array.isArray(RollingDatePointEntry)) {
    const [optionValue] = RollingDatePointEntry;
    return optionValue;
  }
  return undefined;
};
export default RollingDatePointConfig;